import useProjects from './useProjects'

export default function useProject(projectId) {
    const projects = useProjects()
    return projects.find((x) => x.id === projectId)
}
